import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["to", "label", "eventLabel", "ariaLabel", "newTab", "className", "onClick"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _isEmpty from 'lodash/isEmpty';
import { getValidProps } from '../../modules/foundation/services/props';
export function formatUriScheme(to) {
  if (to.startsWith('mailto://')) {
    return to.replace('mailto://', 'mailto:');
  }
  if (to.startsWith('tel://')) {
    return to.replace('tel://', 'tel:');
  }
  return to;
}
export function getOutboundLinkContainerProps(_ref) {
  var to = _ref.to,
    label = _ref.label,
    eventLabel = _ref.eventLabel,
    ariaLabel = _ref.ariaLabel,
    newTab = _ref.newTab,
    className = _ref.className,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var validProps = ['href', 'target', 'rel', 'tittle', 'download', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'aria-label', 'aria-labelledby', 'aria-selected', 'aria-expanded', 'aria-checked', 'aria-busy', 'style', 'id', 'ref', 'role'];
  var validRestProps = getValidProps(rest, validProps);
  var linkProps = newTab ? {
    href: to,
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {
    href: to
  };
  var options = _objectSpread(_objectSpread(_objectSpread({}, linkProps), validRestProps), {}, {
    onClick: onClick
  });
  if (!_isEmpty(className)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      className: className
    });
  }
  var finalAriaLabel = ariaLabel || label || eventLabel || '';
  if (!_isEmpty(finalAriaLabel)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      'aria-label': finalAriaLabel
    });
  }
  return options;
}